
import { Box, Grid } from "@mui/material";
import { useCategoriaSeccionCompras } from "../../../hooks/cache";
import { CardsCategorias } from "../components/CardsCategorias";
import { BuscadorXTermino } from "../../components/buscadores";
import { CargandoMedio, MensajeAlertaDanger } from "../../components";
// import { useLocation } from "react-router-dom";






export const CategoriasScreen = () => {


    const { data, isLoading, termino, chageTermino } = useCategoriaSeccionCompras();

    // const location = useLocation();
    // const { state } = location;
    // if(state?.view) {   
    //     localStorage.setItem("view", state?.view)
    //     localStorage.removeItem('cliente');
    // }


    return (

        <Box sx={{ width:'100%' }}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de categorias y productos..." />
            :   <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="productos" playhol="nombre de producto o categoria" />
                {(data?.length < 1)
                ?   <MensajeAlertaDanger titulo="No hay información de categorias y prodcutos..." />
                :   <Grid container spacing={4} sx={{ justifyContent:"center", alignItems:"center" }}>
                        {data.map((categoria) => (
                            <CardsCategorias key={categoria.id} url="/super/filtro" {...categoria} />
                        ))}
                    </Grid>
                }
                </>
            }
        </Box>

    )
}
